/**
 * @generated SignedSource<<29346b674e1b42887e287c32fb815b33>>
 * @relayHash 172527b195f3de38f68f87e04505d1d4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fe1739c1936ff2ee55182ce83a43567da0d349d9be477ef2c09c954a93430c2e

import type { ConcreteRequest, Query } from 'relay-runtime';
export type getPeopleProps_suggestedGroupsQuery$variables = {
  cloudId: string;
  suggestedUsersCount?: number | null | undefined;
};
export type getPeopleProps_suggestedGroupsQuery$data = {
  readonly jira: {
    readonly jqlBuilder: {
      readonly recentlyUsedUsers: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly displayName: string;
            readonly jqlTerm: string;
            readonly user: {
              readonly picture: AGG$URL;
            } | null | undefined;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly suggestedGroups: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly displayName: string;
            readonly jqlTerm: string;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
    } | null | undefined;
  };
  readonly me: {
    readonly user: {
      readonly picture: AGG$URL;
    } | null | undefined;
  };
};
export type getPeopleProps_suggestedGroupsQuery = {
  response: getPeopleProps_suggestedGroupsQuery$data;
  variables: getPeopleProps_suggestedGroupsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "suggestedUsersCount"
  }
],
v1 = {
  "kind": "ScalarField",
  "name": "picture"
},
v2 = {
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    (v1/*: any*/)
  ]
},
v3 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "suggestedUsersCount"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "jqlTerm"
},
v6 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v7 = {
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 5
    }
  ],
  "concreteType": "JiraJqlGroupFieldValueConnection",
  "kind": "LinkedField",
  "name": "suggestedGroups",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraJqlGroupFieldValueEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "JiraJqlGroupFieldValue",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v5/*: any*/),
            (v6/*: any*/)
          ]
        }
      ]
    }
  ],
  "storageKey": "suggestedGroups(first:5)"
},
v8 = {
  "kind": "LinkedField",
  "name": "user",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    (v1/*: any*/),
    {
      "kind": "ScalarField",
      "name": "id"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "getPeopleProps_suggestedGroupsQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ]
      },
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "JiraQuery",
          "kind": "LinkedField",
          "name": "jira",
          "plural": false,
          "selections": [
            {
              "args": (v3/*: any*/),
              "concreteType": "JiraJqlBuilder",
              "kind": "LinkedField",
              "name": "jqlBuilder",
              "plural": false,
              "selections": [
                {
                  "args": (v4/*: any*/),
                  "concreteType": "JiraJqlUserFieldValueConnection",
                  "kind": "LinkedField",
                  "name": "recentlyUsedUsers",
                  "plural": false,
                  "selections": [
                    {
                      "concreteType": "JiraJqlUserFieldValueEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "concreteType": "JiraJqlUserFieldValue",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v5/*: any*/),
                            (v6/*: any*/),
                            (v2/*: any*/)
                          ]
                        }
                      ]
                    }
                  ]
                },
                (v7/*: any*/)
              ]
            }
          ]
        },
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "getPeopleProps_suggestedGroupsQuery",
    "selections": [
      {
        "concreteType": "AuthenticationContext",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          (v8/*: any*/)
        ]
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v3/*: any*/),
            "concreteType": "JiraJqlBuilder",
            "kind": "LinkedField",
            "name": "jqlBuilder",
            "plural": false,
            "selections": [
              {
                "args": (v4/*: any*/),
                "concreteType": "JiraJqlUserFieldValueConnection",
                "kind": "LinkedField",
                "name": "recentlyUsedUsers",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraJqlUserFieldValueEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraJqlUserFieldValue",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v8/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              (v7/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "fe1739c1936ff2ee55182ce83a43567da0d349d9be477ef2c09c954a93430c2e",
    "metadata": {},
    "name": "getPeopleProps_suggestedGroupsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "211d2fa9f683cfafcbb9fab148ee61b6";

export default node;
